<template>
  <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="线路名称" prop="busLinesId" label-width="80px">
        <el-select style="width: 120px;"  @change="selectBusLinesIdChanged" v-model="busLinesId" filterable placeholder="请选择线路名称">
          <el-option
            v-for="item in busLinesList"
            :key="item.Id"
            :value="item.Id"
            :label="item.LineChineseName"
          >
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getBusLinesListPage } from "../../api/api";

export default {
  name: "RunCenterDiagramToolbar",
  data() {
    return {
      busLinesList: [], //线路列表
      busLinesId:"" //线路ID
    };
  },
  methods: {
    getBusLinesList(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLinesList = res.data.response.data;
        this.busLinesId = this.busLinesList.length > 0?this.busLinesList[0].Id:"";
      });
    },
    selectBusLinesIdChanged(busLinesId) {
      this.$emit("callFunction", busLinesId); //将值传给父组件
    },
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLinesList(pageSizePara);
  }
};
</script>